import { DateInputWUT } from '@wix/form-fields/wut';

export default DateInputWUT;
